var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/Base.jinja"] = require( "front/Base.jinja" );
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/IllustrationComponents/IllustrationItem/IllustrationItem.jinja"] = require( "front/components/IllustrationComponents/IllustrationItem/IllustrationItem.jinja" );




var shim = require("/var/www/django/bangbangstudio.ru/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/StoryboardsAuthor/StoryboardsAuthor.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/Base.jinja", true, "assets/app/front/pages/StoryboardsAuthor/StoryboardsAuthor.jinja", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/StoryboardsAuthor/StoryboardsAuthor.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("macros", t_4);
output += "\n\n";
env.getTemplate("front/components/IllustrationComponents/IllustrationItem/IllustrationItem.jinja", false, "assets/app/front/pages/StoryboardsAuthor/StoryboardsAuthor.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "IllustrationItem")) {
var t_10 = t_7.IllustrationItem;
} else {
cb(new Error("cannot import 'IllustrationItem'")); return;
}
context.setVariable("IllustrationItem", t_10);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("title"))(env, context, frame, runtime, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
output += t_11;
output += "\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("social"))(env, context, frame, runtime, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
output += t_13;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
output += t_15;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_title(env, context, frame, runtime, cb) {
var lineno = 5;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
context.getSuper(env, "title", b_title, frame, runtime, function(t_17,hole_49) {
if(t_17) { cb(t_17); return; }
hole_49 = runtime.markSafe(hole_49);
output += runtime.suppressValue(hole_49, env.opts.autoescape);
output += " Bang! Bang! • ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"name"), env.opts.autoescape);
cb(null, output);
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_social(env, context, frame, runtime, cb) {
var lineno = 6;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"ogImage") == "") {
output += "\n        <meta property=\"og:title\" content=\"";
output += runtime.suppressValue((lineno = 8, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Иллюстраторское агентство Bang! Bang!"])), env.opts.autoescape);
output += "\"/>\n        <meta name=\"twitter:title\" content=\"";
output += runtime.suppressValue((lineno = 9, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Иллюстраторское агентство Bang! Bang!"])), env.opts.autoescape);
output += "\"/>\n        <meta property=\"og:image\" content=\"";
output += runtime.suppressValue((lineno = 10, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/front/share.png"])), env.opts.autoescape);
output += "\"/>\n        <meta property=\"og:image:url\" content=\"";
output += runtime.suppressValue((lineno = 11, colno = 76, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"build_absolute_uri"), "request[\"build_absolute_uri\"]", context, [(lineno = 11, colno = 83, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/front/share.png"]))])), env.opts.autoescape);
output += "\"/>\n        <meta property=\"og:image:secure_url\" content=\"https://bangbangstudio.ru/static/img/front/share.png\"/>\n        <meta name=\"twitter:image\" content=\"https://bangbangstudio.ru/static/img/front/share.png\">\n    ";
;
}
output += "\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"ogImage") != "") {
output += "\n        <meta property=\"og:title\" content=\"Bang! Bang! • ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"name"), env.opts.autoescape);
output += "\"/>\n        <meta name=\"twitter:title\" content=\"Bang! Bang! • ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"name"), env.opts.autoescape);
output += "\"/>\n        <meta property=\"og:image\" content=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"ogImage"), env.opts.autoescape);
output += "\"/>\n        <meta property=\"og:image:url\" content=\"";
output += runtime.suppressValue((lineno = 19, colno = 76, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"build_absolute_uri"), "request[\"build_absolute_uri\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"ogImage")])), env.opts.autoescape);
output += "\"/>\n        <meta property=\"og:image:secure_url\" content=\"https://bangbangstudio.ru";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"ogImage"), env.opts.autoescape);
output += "\"/>\n        <meta name=\"twitter:image\" content=\"https://bangbangstudio.ru";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"ogImage"), env.opts.autoescape);
output += "\">\n    ";
;
}
output += "\n    <meta property=\"og:type\" content=\"website\"/>\n    <meta property=\"og:image:width\" content=\"1200\"/>\n    <meta property=\"og:image:height\" content=\"630\"/>\n    <meta property=\"og:image:type\" content=\"image/png\"/>\n    <meta property=\"og:url\" content=\"";
output += runtime.suppressValue((lineno = 27, colno = 66, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"build_absolute_uri"), "request[\"build_absolute_uri\"]", context, [])), env.opts.autoescape);
output += "\">\n    <meta property=\"og:description\" content=\"";
output += runtime.suppressValue((lineno = 28, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Иллюстраторское агентство Bang! Bang! — первое и главное в России."])), env.opts.autoescape);
output += "\"/>\n    <meta name=\"twitter:card\" content=\"summary_large_image\"/>\n    <meta name=\"twitter:description\" content=\"";
output += runtime.suppressValue((lineno = 30, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Иллюстраторское агентство Bang! Bang! — первое и главное в России."])), env.opts.autoescape);
output += "\"/>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 33;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"StoryboardsAuthor\">\n        ";
var t_18;
t_18 = "storyboards";
frame.set("mods", t_18, true);
if(frame.topLevel) {
context.setVariable("mods", t_18);
}
if(frame.topLevel) {
context.addExport("mods", t_18);
}
output += "\n        ";
output += runtime.suppressValue((lineno = 36, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"includeComponent"), "macros[\"includeComponent\"]", context, ["front/components/Common/TopBar/TopBar.jinja",[],runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "mods"),"caller": (function (){var macro_t_19 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_20 = "";;
frame = frame.pop();
return new runtime.SafeString(t_20);
});
return macro_t_19;})()})])), env.opts.autoescape);
output += "\n\n        <div class=\"StoryboardsAuthor-select\">\n            <div class=\"StoryboardsAuthor-select-wrapper\"></div>\n            ";
output += "\n            <div class=\"StoryboardsAuthor-selectPopup\">\n                <div class=\"StoryboardsAuthor-selectPopup-wrapper\"></div>\n            </div>\n        </div>\n\n        <div class=\"StoryboardsAuthor-select-description\"></div>\n\n        ";
output += "\n        <div class=\"StoryboardsAuthor-wrapper\"></div>\n\n        <button class=\"StoryboardsAuthor-more hidden isHide\" data-scroll data-scroll-offset=\"60\" id=\"lazy_more\">";
output += runtime.suppressValue((lineno = 51, colno = 116, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Загрузить еще"])), env.opts.autoescape);
output += "</button>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_title: b_title,
b_social: b_social,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/StoryboardsAuthor/StoryboardsAuthor.jinja"] , dependencies)